module.exports = __webpack_public_path__ + "static/media/idea.1d991957.svg";